import React, { useEffect, useState } from 'react'

import { CircularProgress, IconButton, IconButtonProps } from '@mui/material'

interface Props {
  onClick?: () => void
  isLoading?: boolean
  href?: any
  size?: string
}

export const ActionIconButton: React.FC<Props & IconButtonProps> = ({
  onClick,
  isLoading,
  color,
  href,
  size,
  children,
}) => {
  const [showSpinner, setShowSpinner] = useState(false)
  useEffect(() => {
    setShowSpinner(false)
    const timer = setTimeout(() => setShowSpinner(isLoading || false), 100, true)
    return () => clearTimeout(timer)
  }, [isLoading])

  return (
    <IconButton
      onClick={onClick}
      disabled={!!isLoading}
      color={color || 'primary'}
      href={href}
      size={size || 'large'}
    >
      {!!isLoading && showSpinner ? <CircularProgress size={24} /> : children}
    </IconButton>
  )
}
